import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { LoginForm } from '../components';
import { loginUser } from '../redux/actions';
import { colors } from '../constants';

const Wrapper = styled.div`
  display: flex;
  height: 100vh;
`;

const LeftContent = styled.div`
  background: ${colors.purpleDark};
  width: 50%;
`;


class Login extends PureComponent {
  state = {
    email: '',
    password: '',
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (event) => {
    const { email, password } = this.state;
    this.props.loginUser(email, password);
    event.preventDefault();
  };

  render() {
    const { errorMessage: error } = this.props;
    return (
      <Wrapper>
        <LeftContent />
        <LoginForm
          email={this.state.email}
          password={this.state.password}
          handleInputChange={this.handleInputChange}
          handleSubmit={this.handleSubmit}
          notification={error}
        />
      </Wrapper>
    );
  }
}

Login.propTypes = {
  loginUser: PropTypes.func.isRequired,
};

const mapStateToProps = ({ auth }) => {
  const { errorMessage } = auth;
  return {
    errorMessage,
  };
};

export default connect(mapStateToProps, { loginUser })(Login);
